// src/utils/handleSubmit.js

export function createHandleSubmit({
  chatInput,
  copilotInput,
  waitingForResponse,
  setWaitingForResponse,
  setIsMainChatLoading,
  setIsCopilotLoading,
  messageList,
  setMessageList,
  setDocxData,
  setpdfData,
  convertToPdf,
  setChatInput,
  setCopilotMessages,
  setCopilotInput,
  uid,
  gptVersion,
  location,
  uploadedDoc,
  baseurl,
  selectedDocs,
}) {
  return async function handleSubmit(source) {
    const text = source === "copilot" ? copilotInput : chatInput;
    if (!waitingForResponse && text) {
      const plainText =
        new DOMParser().parseFromString(text, "text/html").body.textContent ||
        "";

      setWaitingForResponse(true);
      if (source === "main") {
        setIsMainChatLoading(true);
      } else {
        setIsCopilotLoading(true);
      }

      const newUserMessage = {
        id: `${Date.now()}-${messageList.length}`,
        user: "user",
        message: plainText,
      };

      const updatedMessages = [...messageList, newUserMessage];

      if (source === "main") {
        setMessageList((prev) => [...prev, newUserMessage]);
        setDocxData((prev) => [...prev, newUserMessage]);
        setpdfData(convertToPdf([...messageList, newUserMessage]));
        setChatInput("");
      } else {
        setCopilotMessages((prev) => [...prev, newUserMessage]);
        setCopilotInput("");
      }

      const body = {
        query: text,
        uid,
        profile:
          location.state?.currentClient?.organization_name ||
          location.state.profileName,
        gptVersion,
        client_organization_id:
          location.state?.currentClient?.client_id || location.state.clientID,
        grant_proposal_form_id:
          location.state?.formDetails?.id ||
          location.state.grantProposalForm_id,
        grant_proposal: location.state?.formDetails || location.state.formData,
        source,
      };

      if (source === "copilot" && selectedDocs && selectedDocs.length > 0) {
        body.file_ids = selectedDocs;
      }

      try {
        const endpoint =
          source === "copilot"
            ? `${baseurl}/gptRun/aiapp_copilot_multiple`
            : `${baseurl}/gptRun/aiapp`;

        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });

        const data = await response.json();
        console.log("API response:", data);

        if (source === "copilot") {
          let botMessageText = "No response available";

          if (data.results && Array.isArray(data.results)) {
            // Merge all responses into one string
            botMessageText = data.results
              .map((r) => `📄 ${r.file_id}\n${r.content}`)
              .join("\n\n---\n\n");
          } else if (data.message) {
            botMessageText = data.message;
          }

          const newBotMessage = {
            id: `${Date.now()}-${messageList.length}`,
            user: "bot",
            message: botMessageText,
          };

          setCopilotMessages((prev) => [...prev, newBotMessage]);
        } else {
          // main chat → always one bot message
          const newBotMessage = {
            id: `${Date.now()}-${messageList.length}`,
            user: "bot",
            message: data.message || "No response available",
          };

          const updatedMessagesWithResponse = [
            ...updatedMessages,
            newBotMessage,
          ];
          setMessageList(updatedMessagesWithResponse);
          setDocxData(updatedMessagesWithResponse);
          setpdfData(convertToPdf(updatedMessagesWithResponse));
        }
      } catch (error) {
        console.error("error:", error);
      } finally {
        setWaitingForResponse(false);
        if (source === "main") {
          setIsMainChatLoading(false);
        } else {
          setIsCopilotLoading(false);
        }
      }
    }
  };
}
